module.exports = __webpack_public_path__ + "static/media/remove-promo-code.325db696.svg";